import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold" }, "Active Payment Method", -1)
const _hoisted_4 = { class: "mt-2 text-base" }
const _hoisted_5 = { class: "mt-2 text-base" }
const _hoisted_6 = { class: "mt-2 text-base" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_8 = { class: "" }
const _hoisted_9 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_10 = { class: "flex flex-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StripeElement = _resolveComponent("StripeElement")!
  const _component_LoadingButton = _resolveComponent("LoadingButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.payment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("p", _hoisted_4, "Card Type: " + _toDisplayString(_ctx.payment.creditCardType), 1),
            _createElementVNode("p", _hoisted_5, "Last Four: " + _toDisplayString(_ctx.payment.lastFour), 1),
            _createElementVNode("p", _hoisted_6, " Exp: " + _toDisplayString(_ctx.payment.expirationMonth) + " / " + _toDisplayString(_ctx.payment.expirationYear), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (!(_ctx.updating && !_ctx.payment))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "primary-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updating = !_ctx.updating))
            }, _toDisplayString(_ctx.updating ? 'Cancel' : _ctx.payment ? 'Update' : 'Add Payment'), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.updating)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_StripeElement, {
            element: _ctx.cardElement,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.event = $event))
          }, null, 8, ["element"]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_LoadingButton, {
              class: "mt-4",
              disabled: false,
              loading: _ctx.loading,
              onClick: _ctx.registerCard
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Card")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]),
          (_ctx.event && _ctx.event.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.event.error.message), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}